import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Formik, Form } from 'formik';
import { IconButton, TextField, Typography, Button, Stack, Box, MenuItem } from '@mui/material';
import Iconify from './Iconify';

const Filter = ({ toggleFilter, applyFilters }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleClick}>
            <Iconify icon="ic:round-filter-list" />
            <Typography variant="h6"> Filter</Typography>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Formik
              initialValues={{
                fullname: '',
                mobileNumber: '',
                matchType: '',
              }}
              onSubmit={async (values) => {
                applyFilters(values);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <Form style={{ padding: '10px' }}>
                  <Stack
                    spacing={1}
                    direction="column"
                    sx={{ minWidth: { lg: '400px', md: '400px', sm: '400px', xl: '400px' } }}
                  >
                    <Stack spacing={1} direction={{ lg: 'row', xl: 'row', md: 'row', sm: 'row', xs: 'column' }}>
                      <TextField
                        id="fullname"
                        name="fullname"
                        label="Full Name"
                        fullWidth
                        value={values.fullname}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack spacing={1} direction={{ lg: 'row', xl: 'row', md: 'row', sm: 'row', xs: 'column' }}>
                      <TextField
                        type="email"
                        id="mobileNumber"
                        name="mobileNumber"
                        label="Email"
                        fullWidth
                        value={values.mobileNumber}
                        onChange={handleChange}
                      />
                      <TextField
                        id="matchType"
                        select
                        name="matchType"
                        label="Match Type"
                        fullWidth
                        value={values.matchType}
                        onChange={handleChange}
                      >
                        <MenuItem value="GROUP">GROUP</MenuItem>
                        <MenuItem value="PRE_QUARTER">PRE QUARTER</MenuItem>
                        <MenuItem value="QUARTER">QUARTER</MenuItem>
                        <MenuItem value="SEMI_FINAL">SEMI FINAL</MenuItem>
                        <MenuItem value="THIRD_PLACE">THIRD PLACE</MenuItem>
                        <MenuItem value="FINAL">FINAL</MenuItem>
                      </TextField>
                    </Stack>
                    <Button variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default Filter;
